import { Component, OnInit } from '@angular/core';
import { UiVersionService } from 'on-shared/_services/ui-version.service';

/** Remembered per browser: a dismissed invitation stays out of the way. */
const DISMISSED_KEY = 'ox_ui_banner_dismissed';

/**
 * Invitation to try the new front end, shown to the users the roll-out
 * targets (PostHog flag) until they try it or put it off.
 */
@Component({
    selector: 'on-new-ui-banner',
    templateUrl: './new-ui-banner.component.html',
    styleUrls: ['./new-ui-banner.component.scss'],
})
export class NewUiBannerComponent implements OnInit {
    dismissed = false;

    constructor(public uiVersion: UiVersionService) {}

    ngOnInit() {
        try {
            this.dismissed = localStorage.getItem(DISMISSED_KEY) === '1';
        } catch {
            this.dismissed = false;
        }
        this.uiVersion.watchRollout();
    }

    dismiss() {
        this.dismissed = true;
        try {
            localStorage.setItem(DISMISSED_KEY, '1');
        } catch {
            // Private mode: the banner simply comes back next time.
        }
    }
}
